module.exports = __webpack_public_path__ + "static/img/accommodation-convenience-icon01.49af926b.svg";